<template>
  <b-form-group
    :id="`period-impression-target-${periodIndex}-fieldset`"
    :label-for="`period-impression-target-${periodIndex}-input`"
    label-class="form-label"
    class="mb-0"
  >
    <template
      v-if="periodIndex === 0"
      slot="label"
    >
      Impression Target <span class="form-required">*</span>
    </template>
    <b-form-input
      :id="`period-impression-target-${periodIndex}-input`"
      :ref="`period-impression-target-${periodIndex}-input`"
      :value="impressionTarget"
      @input="updateImpressionTargetValue"
      :data-test="`period-impression-target-${periodIndex}-input`"
      :disabled="isImpressionTargetInputDisabled"
    />
  </b-form-group>
</template>
<script>
import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

import helper from '@/core/helper';

export default {
  name: 'ImpressionTarget',
  props: {
    periodIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    initialImpressionTarget: {
      type: [Number, null],
      required: false,
      default: null,
    },
    hasPeriodEnded: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAddImpressionTargetChecked: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      impressionTarget: null,
      clearField: false,
    };
  },
  computed: {
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_DRAFT,
      campaignTypes.GET_IS_NEW_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
      campaignTypes.GET_SELECTED_CURRENCY,
    ]),
    isImpressionTargetInputDisabled() {
      if (this.GET_IS_CAMPAIGN_DRAFT) return false;
      return this.GET_IS_CAMPAIGN_READONLY || this.hasPeriodEnded;
    },
  },
  methods: {
    updateImpressionTargetValue: helper.debounce(async function updateImpressionTargetValue(newValue) {
      if (this.isImpressionTargetInputDisabled) return;
      this.impressionTarget = newValue === '' ? null : Number(newValue.replace(/[^\d]/g, ''));
      await this.$nextTick();
      this.$refs[`period-impression-target-${this.periodIndex}-input`].$el.value = this.impressionTarget;
      this.$emit('updateImpressionTarget', this.impressionTarget);
    }, 500),
  },
  created() {
    this.impressionTarget = this.initialImpressionTarget;
  },
};
</script>
